//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

export default {
  props: ["selectedService"],
  data() {
    return {
      errors: null,
      success: null,
      showpopupSurvey: false,
      services: [
        "Kontrola stanu technicznego i geometria",
        "Kontrola stanu karoserii",
        "Rabat do 30% przy kompletach usług",
        "Bezpłatne ramki pod tablice",
      ],
      form: {
        first_name: "",
        last_name: "",
        email: "",
        phone_number: "",
        service: "",
        acceptEmail: "",
        acceptSms: "",
        acceptPhone: "",
        campaign_id: 22,
        department_id: 3,
        origin_id: 5,
        dealer_id: 1,
        external_portal: "https://centrumwroclaw.pl/10lat/",
      },
    };
  },
  watch: {
    selectedService() {
      this.form.service = this.selectedService;
      window.scrollTo(0, this.$el.offsetTop + this.$el.offsetHeight + 500);
    },
  },
  validate: {
    messages: {
      first_name: {
        require: "To pole jest wymagane!",
      },
      last_name: {
        require: "To pole jest wymagane!",
      },
      phone_number: {
        requireGroup: "E-mail lub telefon jest wymagany!",
        phone: "Błędny numer telefonu!",
      },
      email: {
        requireGroup: "E-mail lub telefon jest wymagany!",
        email: "Błędny adres e-mail!",
      },
      //   acceptPhone: {
      //     requireGroup: "Proszę wybrać formę kontaktu",
      //   },
      //   acceptEmail: {
      //     requireGroup: "Proszę wybrać formę kontaktu",
      //   },
      //   acceptSms: {
      //     requireGroup: "Proszę wybrać formę kontaktu",
      //   },
    },
    rules: {
      first_name: {
        require: true,
      },
      last_name: {
        require: true,
      },
      phone_number: {
        requireGroup: "data",
        phone: true,
      },
      email: {
        requireGroup: "data",
        email: true,
      },
      //   acceptPhone: {
      //     requireGroup: "contact",
      //   },
      //   acceptEmail: {
      //     requireGroup: "contact",
      //   },
      //   acceptSms: {
      //     requireGroup: "contact",
      //   },
    },
  },
  methods: {
    send: function () {
      this.errors = this.$vaLittle.check(this.form);
      console.log(this.errors);
      if (!this.errors.errors) {
        grecaptcha.ready(async () => {
          grecaptcha.execute('6LdfEVopAAAAAIIhGirCfCTzSZZyTRd-VT_C6-bb', { action: 'submit' }).then(async (token) => {
            this.$http
              .post("https://centrumwroclaw.pl/send.php", {
                ...this.form,
                token,
                description: `Wybrana usługa: ${this.form.service}`,
              })
              .then((response) => {
                this.success = response.data.status;
                this.showpopupSurvey = true;
          });
        });
          });
      } else {
        console.log("IS NOT OK!");
      }
    },
  },
};
